/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_EyebrowInputs */

const tr_landing_shortcuts_eyebrow = /** @type {(inputs: Landing_Shortcuts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hız · kısayol · bulut`)
};

const en_landing_shortcuts_eyebrow = /** @type {(inputs: Landing_Shortcuts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`speed · shortcuts · cloud`)
};

const de_landing_shortcuts_eyebrow = /** @type {(inputs: Landing_Shortcuts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo · Kurzbefehle · Cloud`)
};

const ru_landing_shortcuts_eyebrow = /** @type {(inputs: Landing_Shortcuts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`скорость · быстрые клавиши · облако`)
};

/**
* | output |
* | --- |
* | "speed · shortcuts · cloud" |
*
* @param {Landing_Shortcuts_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_eyebrow = /** @type {((inputs?: Landing_Shortcuts_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_eyebrow(inputs)
	if (locale === "de") return de_landing_shortcuts_eyebrow(inputs)
	if (locale === "ru") return ru_landing_shortcuts_eyebrow(inputs)
	return tr_landing_shortcuts_eyebrow(inputs)
});